import React from "react";
import LegalLayout from "@/components/site/LegalLayout";
import { COMPANY } from "@/lib/i18n";

const sections = [
  {
    h: { ro: "1. Informații generale", en: "1. General information" },
    p: [
      {
        ro: `Acest site web (${COMPANY.name}) este operat de ${COMPANY.legal}, cu sediul în ${COMPANY.location.ro}. Prin accesarea și utilizarea acestui site, sunteți de acord cu prezenții termeni și condiții. Dacă nu sunteți de acord cu oricare dintre acești termeni, vă rugăm să nu utilizați acest site.`,
        en: `This website (${COMPANY.name}) is operated by ${COMPANY.legal}, headquartered at ${COMPANY.location.en}. By accessing and using this site, you agree to these terms and conditions. If you do not agree with any of these terms, please do not use this website.`,
      },
    ],
  },
  {
    h: { ro: "2. Obiectul site-ului", en: "2. Purpose of the website" },
    p: [
      {
        ro: "Site-ul are un rol strict informativ, prezentând serviciile de transport rutier național și internațional de mărfuri oferite de societatea noastră. Site-ul nu permite comenzi sau plăți online; orice colaborare se stabilește direct, prin contact telefonic, e-mail sau întâlnire, urmată de un contract de transport/prestări servicii separat.",
        en: "The website is strictly informational, presenting the national and international road freight transport services offered by our company. The website does not allow online orders or payments; any collaboration is established directly, via phone contact, email or meeting, followed by a separate transport/services agreement.",
      },
    ],
  },
  {
    h: { ro: "3. Proprietate intelectuală", en: "3. Intellectual property" },
    p: [
      {
        ro: `Conținutul acestui site (texte, imagini, logo, grafică) este proprietatea ${COMPANY.legal} sau este utilizat cu drepturile necesare și este protejat de legislația privind drepturile de autor. Reproducerea, distribuirea sau utilizarea conținutului fără acordul scris prealabil este interzisă.`,
        en: `The content of this website (text, images, logo, graphics) is the property of ${COMPANY.legal} or is used with the necessary rights and is protected by copyright law. Reproduction, distribution or use of the content without prior written consent is prohibited.`,
      },
    ],
  },
  {
    h: { ro: "4. Limitarea răspunderii", en: "4. Limitation of liability" },
    p: [
      {
        ro: "Depunem eforturi rezonabile pentru a menține informațiile de pe site actualizate și corecte, însă nu garantăm absența erorilor. Societatea nu răspunde pentru eventuale prejudicii rezultate din utilizarea sau imposibilitatea utilizării site-ului, din erori, omisiuni sau întreruperi ale funcționării acestuia.",
        en: "We make reasonable efforts to keep the information on the site up to date and accurate, but we do not guarantee the absence of errors. The company is not liable for any damages resulting from the use or inability to use the site, or from errors, omissions or interruptions in its operation.",
      },
    ],
  },
  {
    h: { ro: "5. Linkuri către site-uri terțe", en: "5. Links to third-party websites" },
    p: [
      {
        ro: "Site-ul poate conține linkuri către pagini administrate de terți (de exemplu, hărți, rețele sociale, ANPC). Nu avem control asupra conținutului acestor site-uri și nu ne asumăm răspunderea pentru politicile sau practicile lor.",
        en: "The site may contain links to pages administered by third parties (e.g. maps, social networks, ANPC). We have no control over the content of these sites and assume no responsibility for their policies or practices.",
      },
    ],
  },
  {
    h: { ro: "6. Protecția datelor cu caracter personal", en: "6. Personal data protection" },
    p: [
      {
        ro: "Datele de contact transmise prin intermediul canalelor afișate pe site (telefon, e-mail, WhatsApp) sunt utilizate exclusiv pentru a răspunde solicitărilor dumneavoastră și pentru derularea eventualei colaborări, în conformitate cu Regulamentul (UE) 2016/679 (GDPR). Pentru detalii privind utilizarea cookie-urilor, consultați Politica de cookies.",
        en: "Contact details submitted through the channels displayed on the site (phone, email, WhatsApp) are used exclusively to respond to your requests and to carry out any resulting collaboration, in accordance with Regulation (EU) 2016/679 (GDPR). For details on the use of cookies, please see the Cookie Policy.",
      },
    ],
  },
  {
    h: { ro: "7. Soluționarea litigiilor (SAL/SOL)", en: "7. Dispute resolution (ADR/ODR)" },
    p: [
      {
        ro: "În cazul unui litigiu, consumatorii au dreptul de a apela la Autoritatea Națională pentru Protecția Consumatorilor (ANPC) sau la platforma Europeană de Soluționare Online a Litigiilor (SOL), disponibile prin linkurile afișate în subsolul site-ului.",
        en: "In case of a dispute, consumers have the right to contact the National Authority for Consumer Protection (ANPC) or the European Online Dispute Resolution (ODR) platform, available via the links displayed in the site footer.",
      },
    ],
  },
  {
    h: { ro: "8. Modificarea termenilor", en: "8. Changes to the terms" },
    p: [
      {
        ro: "Ne rezervăm dreptul de a actualiza periodic acești termeni și condiții, fără notificare prealabilă. Versiunea în vigoare este cea publicată pe această pagină, la data ultimei actualizări.",
        en: "We reserve the right to periodically update these terms and conditions, without prior notice. The version in force is the one published on this page, as of the date of the last update.",
      },
    ],
  },
  {
    h: { ro: "9. Contact", en: "9. Contact" },
    p: [
      {
        ro: `Pentru orice întrebări legate de acești termeni și condiții, ne poți contacta la ${COMPANY.email} sau la numărul de telefon ${COMPANY.phone}.`,
        en: `For any questions regarding these terms and conditions, you can contact us at ${COMPANY.email} or at phone number ${COMPANY.phone}.`,
      },
    ],
  },
];

export default function TermsConditions() {
  return (
    <LegalLayout
      label={{ ro: "Legal", en: "Legal" }}
      title={{ ro: "Termeni și condiții", en: "Terms & conditions" }}
      updated="22.07.2026"
      sections={sections}
    />
  );
}
